import { Stack, StackProps, styled } from '@mui/material';

import { hexToRgba } from '../../../../../utils/color';
import { generateClasses } from '../../../../../utils/helper';
import InnerLayout from '../InnerLayout';

export const recordingAttendanceScreenClasses = generateClasses('recordingAttendanceScreen', [
  'background',
  'attendanceInProgressNotification',
]);

export const Root = styled((props: StackProps) => (
  <Stack justifyContent="center" alignItems="center" height="100%" {...props} />
))(({ theme }) => ({
  position: 'relative',
  [`& .${recordingAttendanceScreenClasses.background}`]: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  [`& .${recordingAttendanceScreenClasses.attendanceInProgressNotification}`]: {
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
}));

export const BlurredInnerLayout = styled(InnerLayout)(({ theme }) => ({
  boxShadow: `0px 0px 4px 2px ${hexToRgba(theme.palette.error[500], 0.3)}`,
  backdropFilter: 'blur(10px)',
}));
